import styled from 'styled-components';

import { rem } from 'approot/shared/style';

type TableWrapperProps = {
  $maxWidth: number;
};
export const TableWrapper = styled.div<TableWrapperProps>`
  max-width: ${({ $maxWidth }) => rem($maxWidth)};
`;
